import { FC, ReactNode, useContext, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { useIdleTimer } from "react-idle-timer";
import {
  checkTokenExpirationInMs,
  idleTimerMS,
  refreshAccessTokenInSec,
} from "./constants";
import { timeToExpireInSecond } from "./utils";
import { getLocal } from "../common/utils";

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const { signoutRedirect, signinSilent } = useContext(AuthContext);

  // const onAction = () => {};

  // const onPrompt = () => {};

  // const onIdle = () => signoutRedirect();

  // useIdleTimer({
  //   onAction,
  //   onPrompt,
  //   onIdle,
  //   timeout: idleTimerMS,
  //   crossTab: true,
  //   debounce: 500,
  // });

  useEffect(() => {
    const timer = setInterval(() => {
      const userSessionTimeout = Number(getLocal("userSessionTimeout"));
      const timeRemaining = timeToExpireInSecond();
      const currentTime = Math.floor(Date.now() / 1000);
      if (currentTime < userSessionTimeout) {
        if (timeRemaining < refreshAccessTokenInSec) {
          signinSilent();
        }
      } else {
        signoutRedirect();
      }
    }, checkTokenExpirationInMs);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return <>{children}</>;
};

export default Layout;
